/** Hebrew first names — boys vs girls for two AI seats (one of each, random sides). */
const BOYS_NAMES = [
  'יוסי',
  'דני',
  'אבי',
  'רון',
  'עומר',
  'גיל',
  'איתן',
  'ניר',
  'אלון',
  'בן',
  'עידו',
  'מתן',
  'אמיר',
  'נדב',
  'עופר',
  'אריאל',
  'אור',
  'גלעד',
  'יונתן',
  'רועי',
  'אייל',
  'טום',
  'לביא',
  'דור',
];

const GIRLS_NAMES = [
  'מיכל',
  'נועה',
  'שרה',
  'תמר',
  'מאיה',
  'יעל',
  'רותם',
  'שירה',
  'הילה',
  'קרן',
  'ענת',
  'דנה',
  'טל',
  'אורית',
  'לימור',
  'דפנה',
  'מירי',
  'שקד',
  'הדר',
  'נוי',
  'נגה',
  'ליה',
  'מאי',
  'שחר',
];

/**
 * One random boy + one random girl; 50% swap so either side can be either gender.
 * @param {() => number} rng
 * @returns {[string, string]} [leftSeatName, rightSeatName]
 */
export function pickBoyAndGirlOpponentNames(rng = Math.random) {
  const boy = BOYS_NAMES[Math.floor(rng() * BOYS_NAMES.length)];
  const girl = GIRLS_NAMES[Math.floor(rng() * GIRLS_NAMES.length)];
  if (rng() < 0.5) return [boy, girl];
  return [girl, boy];
}
